import { useEffect, useState } from "react";

import PageHead from "../Head";
import { Provider } from "react-redux";
import Store from "@/redux/store";
import Context from "@/context/Context";
import HeaderStyleTen from "@/components/Header/HeaderStyle-Ten";
import MobileMenu from "@/components/Header/MobileMenu";
import Cart from "@/components/Header/Offcanvas/Cart";
import BackToTop from "../backToTop";
import FooterThree from "@/components/Footer/Footer-Three";
import TeamOne from "@/components/Team/TeamOne";
import { getData, postData } from "@/Action/api";
import Pagination from "@/components/Common/Pagination";
const TestiMonials = () => {
  const [testimonialData, setTestiMonialsData] = useState([]);
  const fetchData = async (currentPage = 1) => {
    try {
      const navData = await getData(`/storyboard?page=${currentPage}&size=10`);

      setTestiMonialsData(navData?.data);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchData();

    const handleURLChange = () => fetchData();
    window.addEventListener("popstate", handleURLChange);

    return () => {
      window.removeEventListener("popstate", handleURLChange);
    };
  }, []);
  return (
    <div>
      {" "}
      <PageHead title="Testimonials-Immigration Guru's"
        description="Success stories from Indian students who studied abroad with The Immigration Gurus — real experiences with admissions, visas and settling in overseas." />
      <Provider store={Store}>
        <Context>
          <HeaderStyleTen headerSticky="rbt-sticky" headerType={true} />
          <MobileMenu />
          <Cart />
          <div className="rbt-team-area bg-color-extra2 pb--60 pt--60 ">
            <div className="container">
              <div className="row mb--60">
                <div className="col-lg-12">
                  <div className="section-title text-left">
                    <h1 className="title h2">
                      Empowering Students, Transforming Futures.
                    </h1>
                    <p
                      className="description has-medium-font-size mt--20 flex"
                      style={{
                        display: "flex",
                        gap: "0.5rem",
                      }}
                    >
                      We guide Indian students to study abroad, offering support
                      and creating opportunities for a brighter future.{" "}
                    </p>
                  </div>
                </div>
              </div>

              <h2 className="title h4 mb--20">Student Success Stories</h2>
              <TeamOne Type={2} TestiMonialsData={testimonialData?.story} />
              <div className="row">
                <div className="col-lg-12 mt--60">
                  <Pagination
                    totalPages={testimonialData?.pagination?.totalPages}
                    pageNumber={testimonialData?.pagination?.currentPage}
                    handleClick={(value) => {
                      fetchData(value);
                    }}
                  />
                </div>
              </div>
            </div>
          </div>{" "}
          <BackToTop />
          <FooterThree />
        </Context>
      </Provider>
    </div>
  );
};

export default TestiMonials;
